import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FeatureFlagsService } from './feature-flags.service';

/**
 * WOLF-3283 — `/prestamos` redirects to the unified `/tesoreria` screen only when the
 * `tesoreria_circuito_v2` flag is on; with it off the current Préstamos page is untouched.
 * `/prestamos/simulador` is a different route and never goes through this guard.
 */
export const prestamosToTesoreriaGuard: CanActivateFn = async () => {
  // inject() only works synchronously, so resolve both before awaiting.
  const flags = inject(FeatureFlagsService);
  const router = inject(Router);
  const enabled = await flags.whenLoaded();
  return enabled ? router.createUrlTree(['/tesoreria']) : true;
};
